export interface Bonus {
  number: string
  value: string
  title: string
  description: string
  image: string
}
export const bonuses: Bonus[] = [
  {
    number: '01',
    value: '$50',
    title: 'Biblia compingu jazzowego',
    description:
      'Każdy wzorzec compingu, którego potrzebują Twoi uczniowie, uporządkowany według feelingu i trudności — voicingi, rytmy i ćwiczenia gotowe do rozdania.',
    image: 'https://cdn.magicpatterns.com/uploads/uehCvQGpzpas3mxNFv9QGu/port_jazz_pol.webp',
  },
  {
    number: '02',
    value: '$50',
    title: 'Opanuj progresję ii-V-I we wszystkich 12 tonacjach',
    description:
      'Pełny cykl rozpisany we wszystkich dwunastu tonacjach, z prowadzeniem głosów, substytucjami i ścieżkami ćwiczeń dla każdego poziomu.',
    image: 'https://cdn.magicpatterns.com/uploads/kf7UTh9dZXeQC6PNy2Rab7/port_jazz_pol_2.webp',
  },
  {
    number: '03',
    value: '$50',
    title: 'Biblioteka standardów jazzowych — szybka nauka',
    description:
      'Rozpisane standardy z melodią, harmonią i wskazówkami do improwizacji — nowy utwór nauczysz bez żadnych przygotowań.',
    image: 'https://cdn.magicpatterns.com/uploads/vcsXyUfBLJM2H4EK1BHy7r/port_jazz_3_pol.webp',
  },
  {
    number: '04',
    value: '$50',
    title: 'Jazzowe jam session — przewodnik przetrwania',
    description:
      'Savoir-vivre, odliczanie, wymiana chorusów i sposoby wyjścia z pomyłek — wszystko, czego uczniowie potrzebują przed pierwszym jamem.',
    image: 'https://cdn.magicpatterns.com/uploads/g8n2YAHqzg83vifvwhnGSQ/port_jazz_4_pol.webp',
  },
  {
    number: '05',
    value: '$50',
    title: 'Mistrzowski kurs transkrypcji jazzowej',
    description:
      'Metoda krok po kroku, jak uczyć uczniów zdejmowania fraz ze słuchu — od czterotaktowych motywów po całe solówki.',
    image: 'https://cdn.magicpatterns.com/uploads/1bBtq1ZYm8Pwj65mYecDDU/port_pol_5_jazz.webp',
  },
]
